var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorPlanMobileRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 52,
    viewBox: "0 0 28 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13608_21659)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13608_21659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0.000391483C27.9482 0.000125516 27.8963 -5.25427e-06 27.8444 -5.25881e-06C12.4664 -6.6032e-06 2.69387e-06 11.6406 1.43853e-06 26C1.83188e-07 40.3594 12.4664 52 27.8444 52C27.8963 52 27.9482 51.9999 28 51.9996L28 0.000391483Z",
    fill: "#FBD207"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4053 35.33C14.0116 35.7129 13.3945 35.7429 12.9654 35.4002V35.4002C12.453 34.9908 12.4156 34.2248 12.8859 33.7675L20.8737 26L12.8859 18.2325C12.4157 17.7752 12.453 17.0092 12.9655 16.5998V16.5998C13.3945 16.2571 14.0116 16.2871 14.4053 16.67L24 26L14.4053 35.33Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13608_21659",
    x: -4,
    y: -2,
    width: 36,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13608_21659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13608_21659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13608_21659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlanMobileRight);
export default __webpack_public_path__ + "static/media/floor_plan_mobile_right.1a1640fa.svg";
export { ForwardRef as ReactComponent };